import { useToast } from "../components/MessageBox";
import { useTranslation } from "./useTranslation";

export function useCopy() {
    const toast = useToast();
    const { t } = useTranslation();

    return async function copy(text: string): Promise<boolean> {
        try {
            await navigator.clipboard.writeText(text);
            toast?.success(t('COPIED'));
            return true;
        } catch {
            toast?.error(t('COPY_FAILED'));
            return false;
        }
    };
}
